import classNames from 'clsx';
import React, { type ReactElement } from 'react';
import { SHARING_VARIANT } from 'reactApp/components/SharingWindow/SharingNew/Weblink/WeblinkList/SharingNewWeblinkList.types';

import styles from './User.css';
import { useWeblinkAccessRights } from './User.hooks';
import type { UserInfoProps } from './User.types';

export const WeblinkUser = React.memo(function WeblinkUser(props: UserInfoProps): ReactElement | null {
    const {
        user,
        isOwner = false,
        item,
        isPhone,
        isReadOnly,
        variant = SHARING_VARIANT.default,
        isEmbeded,
        hideUserBlock,
        isCompact,
    } = props;

    const userBlock = useWeblinkAccessRights({ user, item, isPhone, isOwner, isReadOnly, variant, hideUserBlock });

    if (!user) {
        return null;
    }

    if (variant === SHARING_VARIANT.tabs) {
        return (
            <div
                className={classNames(styles.root, styles.root_tab, {
                    [styles.root_phone]: isPhone,
                    [styles.root_withDropdown]: !isOwner,
                    [styles.root_embeded]: isEmbeded,
                })}
                data-qa-email={user.email}
                data-qa-status={user.status}
            >
                <img src={user.avatarUrl} className={styles.avatar} />
                <div className={styles.userContainer}>
                    <div className={styles.info}>
                        <div className={styles.email}>{user.email}</div>
                        {isOwner && <div className={styles.annotation}>(вы)</div>}
                    </div>
                    {!isOwner && userBlock}
                </div>
            </div>
        );
    }

    return (
        <div
            className={classNames(styles.root, {
                [styles.root_phone]: isPhone,
                [styles.root_withDropdown]: !isOwner,
                [styles.root_compact]: isCompact,
            })}
            data-qa-email={user.email}
            data-qa-status={user.status}
        >
            <img src={user.avatarUrl} className={styles.avatar} alt={user.email} />
            <div className={styles.userContainer}>
                <div className={styles.info}>
                    {user.name && <div className={classNames(styles.name, { [styles.name_compact]: isCompact })}>{user.name}</div>}
                    <div className={styles.email}>{user.email}</div>
                </div>
                {userBlock}
            </div>
        </div>
    );
});
